import { ChangeDetectionStrategy, Component, HostBinding, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";

import { KsaLimitsAlertContainerInputData, KsaLimitsAlertContent } from "./ksa-limits-alert.model";
import { KsaLimitsAlertService } from "./ksa-limits-alert.service";

@Component({
	selector: "obg-ksa-limits-alert-container",
	templateUrl: "./ksa-limits-alert.container.html",
	styleUrls: ["./ksa-limits-alert.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class KsaLimitsAlertContainer implements OnInit {
	@HostBinding("class.obg-ksa-limits-alert") hostCssClass = true;
	content: KsaLimitsAlertContent | undefined;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: KsaLimitsAlertContainerInputData,
		private ksaLimitsAlertService: KsaLimitsAlertService
	) {}

	ngOnInit(): void {
		this.content = this.ksaLimitsAlertService.getKsaLimitAlertContent(this.data);
	}
}
